import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewportDevice } from '@zep/react';
import { Button } from '@zep/ui';
import S from './PricingAmbassador.module.scss';
// 로컬 작업 불필요
export const PricingAmbassador = () => {
  const {
    locale
  } = useRouter();
  const {
    t
  } = useTranslation(['subscription'], {
    useSuspense: true
  });
  const {
    isMobile
  } = useViewportDevice();
  if (locale !== 'ko') return;
  return <section className={S.section} data-sentry-component="PricingAmbassador" data-sentry-source-file="PricingAmbassador.tsx">
      <div className={S.inner}>
        <div className={S.banner}>
          <div className={S.left}>
            <h2 className={S.title}>
              {t('subscription:pricing.ambassadorBanner.title')}
            </h2>
            <p className={S.description}>
              {t('subscription:pricing.ambassadorBanner.description')}
            </p>
            <div className={S.button}>
              <Button as="a" size={isMobile ? 'sm' : 'md'} href={t('subscription:pricing.ambassadorBanner.buttonLink')} onClick={() => logger.track('home_pricing_edu_plan')} target="_blank" data-sentry-element="Button" data-sentry-source-file="PricingAmbassador.tsx">
                {t('subscription:pricing.ambassadorBanner.buttonTitle')}
              </Button>
            </div>
          </div>
          <div className={S.right}>
            <div className={S.img}>
              <img src="/images/pricing/edu-ambassador.png" alt="edu-ambassador" width={446} height={261} />
            </div>
          </div>
        </div>
      </div>
    </section>;
};